var _rect, _rect2, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLpSocYtIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.897461,
    y: 1.18604,
    width: 47,
    height: 47,
    rx: 11.5,
    fill: "#FFE500",
    fillOpacity: 0.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.897461,
    y: 1.18604,
    width: 47,
    height: 47,
    rx: 11.5,
    stroke: "#FFE500"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.9805 19.0584C33.7515 18.0544 33.0735 17.2624 32.2115 16.9904C30.6525 16.5034 24.3975 16.5034 24.3975 16.5034C24.3975 16.5034 18.1455 16.5034 16.5835 16.9904C15.7245 17.2584 15.0465 18.0504 14.8145 19.0584C14.3975 20.8804 14.3975 24.6854 14.3975 24.6854C14.3975 24.6854 14.3975 28.4904 14.8145 30.3124C15.0435 31.3164 15.7215 32.1084 16.5835 32.3804C18.1455 32.8674 24.3975 32.8674 24.3975 32.8674C24.3975 32.8674 30.6525 32.8674 32.2115 32.3804C33.0705 32.1124 33.7485 31.3204 33.9805 30.3124C34.3975 28.4904 34.3975 24.6854 34.3975 24.6854C34.3975 24.6854 34.3975 20.8804 33.9805 19.0584Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3995 27.686L27.5955 24.686L22.3995 21.686V27.686Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLpSocYtIcon);
export default __webpack_public_path__ + "static/media/lp_soc_yt_icon.fe965d874cd69fdbee895df9871d6126.svg";
export { ForwardRef as ReactComponent };